import BaseModel from "../base/baseModel";

export default class EspecieAnimalModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    franquiaId?: number = null;
}
